import { JobType } from "../../../../../WebWorker/JobType.enum"
import type { CreateTileGraphNodeGrassWavesGeometryV1DataInputItem } from "../createTileGraphNodeGrassWavesGeometryV1WorkerInput"

export interface CreateGrassWavesGeometryJobData {
  type: JobType.GrassWavesGeometry
  nodeDataList: CreateTileGraphNodeGrassWavesGeometryV1DataInputItem[]
  grassBatchCountList: Int8Array
}

export default function createGrassWavesGeometryJobData(
  nodeDataList: CreateTileGraphNodeGrassWavesGeometryV1DataInputItem[],
  grassBatchCountList: Int8Array,
): CreateGrassWavesGeometryJobData {
  return {
    type: JobType.GrassWavesGeometry,
    nodeDataList,
    grassBatchCountList,
  }
}
